module.exports = __webpack_public_path__ + "img/plus.3b658ba7.svg";